import { Feature } from '@tencent/workbench';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import { getQuerySearchParams } from '@src/slide/infrastructure/module/independent/url/param-operation';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';

@Feature()
export default class LocalFileFolderFeature extends BaseTitleBarFeature {
    public openLocalFileFolder = (): void => {
        if (window.mqq?.invoke) {
            window.mqq.invoke('docx', 'showItemInFolder', {
                path: getQuerySearchParams('localFilePath'),
            }, (result) => {
                if (result?.code !== 0 && result?.err) {
                    Snackbar.show({
                        type: 'error',
                        message: result?.err,
                        duration: 2000,
                        autoClose: true,
                    });
                }
            });
        }
    };

    protected getCustomDisabledState(): boolean {
        return !getQuerySearchParams('localFilePath');
    }
}
